import { render } from "./IssueGallery.vue?vue&type=template&id=06ccb4fe&scoped=true"
import script from "./IssueGallery.vue?vue&type=script&lang=js"
export * from "./IssueGallery.vue?vue&type=script&lang=js"

import "./IssueGallery.vue?vue&type=style&index=0&id=06ccb4fe&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3337210614/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ccb4fe"]])

export default __exports__